'use client';

// Third Party Plugins
import React from 'react';
// Types
import { PastScholarshipWinnersListProps } from './types';
// Custom Components
import PostCard from '@/components/cards/PostCard';
import CardGridContainer from '@/components/cards/CardGridContainer';

const PastScholarshipWinnersList: React.FC<PastScholarshipWinnersListProps> = ({
  winners,
}) => {
  return (
    <CardGridContainer>
      {winners.map((winner) => (
        <PostCard
          _id={winner._id}
          key={winner._id}
          image={winner.pastWinnerImg?.asset?.url}
          altText={winner.pastWinnerImg?.alt}
          tagText={winner.pastWinnerTag}
          type={winner._type}
          to={`/past-scholarship-winners/${winner.slug.current}`}
          title={winner.pastWinnerTitle}
          description={winner.pastWinnerContentExcerpt}
          date={winner.publishDate}
        />
      ))}
    </CardGridContainer>
  );
};

export default PastScholarshipWinnersList;
